import MACorpActionsPage from './MACorpActionsPage'
// Uncomment the below to migrate to stateful component
// import MACorpActionsPageContainer from './MACorpActionsPageContainer'

export { MACorpActionsPage }
export default MACorpActionsPage
// Uncomment the below to migrate to stateful component
// export { MACorpActionsPageContainer }
// export default { MACorpActionsPageContainer }
